import { useQuery } from '@tanstack/react-query'
import axios from 'axios'

import { ApiPaths } from '@/utils/apiPaths'

interface Town {
  name: string
  lat: number
  lon: number
  cityUrlSlug: string
}

interface Airport {
  code: string
  name: string
  lat: number
  lon: number
  cityName: string
  displayName: string
  cityUrlSlug: string
}

interface TownsResponse {
  towns: Town[]
  error?: string
}

interface AirportsResponse {
  airports: Airport[]
  error?: string
}

interface TimezoneResponse {
  zoneName: string
  gmtOffset: number
  timestamp: number
  status: string
  formatted: string
}

export const useTowns = (language: string, market = 'eu') => {
  return useQuery<TownsResponse>({
    queryKey: ['towns', market, language],
    queryFn: async () => {
      const { data } = await axios.get<TownsResponse>(ApiPaths.API_TOWNS, {
        params: { region: market, lng: language }
      })
      return data
    }
  })
}

export const usePandfTowns = (language: string, market = 'eu') => {
  return useQuery<AirportsResponse>({
    queryKey: ['pandfTowns', market, language],
    queryFn: async () => {
      const { data } = await axios.get<AirportsResponse>(
        ApiPaths.API_PANDF_TOWNS,
        {
          params: { region: market, lng: language }
        }
      )
      return data
    }
  })
}

export const useTimezone = (
  latitude: string | null,
  longitude: string | null
) => {
  return useQuery<TimezoneResponse>({
    queryKey: ['timezone', latitude, longitude],
    queryFn: async () => {
      const { data } = await axios.get<TimezoneResponse>(
        `https://api.timezonedb.com/v2.1/get-time-zone?key=DMDMEVHSO7V8&format=json&by=position&lat=${latitude}&lng=${longitude}`
      )
      return data
    },
    enabled: !!(latitude && longitude)
  })
}
